import { render, staticRenderFns } from "./DeptSelectTree.vue?vue&type=template&id=46da7ad4&scoped=true"
import script from "./DeptSelectTree.vue?vue&type=script&lang=js"
export * from "./DeptSelectTree.vue?vue&type=script&lang=js"
import style0 from "./DeptSelectTree.vue?vue&type=style&index=0&id=46da7ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46da7ad4",
  null
  
)

export default component.exports